import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-subtitle">SMS Messaging Privacy Policy</p>
        <p className="effective-date">Effective Date: February 4, 2026</p>

        <div className="legal-content">
          <p className="intro-text">
            One Aligned, Inc. ("we," "us," "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how One Aligned, Inc. collects and uses information about you when you opt-in to receive SMS messages from us.
          </p>

          <section className="legal-section">
            <h2>Information We May Collect</h2>
            <p>We may collect limited information when you interact with our website, including:</p>
            <p>When you opt-in to receive SMS messages, we collect:</p>
            <ul>
              <li>Your phone number</li>
              <li>Consent to send SMS messages</li>
              <li>Your email address</li>
              <li>Your basic contact information</li>
              <li>Your messaging history</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>How We Collect Your Information</h2>
            <p>
              We may collect your information directly from you, such as when you complete a form or contact us or automatically, such as when you interact with our website.
            </p>
          </section>

          <section className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Send you the SMS messages you've opted in to receive</li>
              <li>Provide updates, promotions, or other relevant content based on your preferences</li>
              <li>Operate our business</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Choices and Controls</h2>
            <p>
              You can opt out of receiving SMS messages at any time by replying <strong>STOP</strong> to any message we send you. You can review our <Link to="/terms-of-use" className="legal-link">Terms of Use</Link> for additional information about the opt-out process.
            </p>
          </section>

          <section className="legal-section">
            <h2>To Whom We Disclose Your Information</h2>
            <p>We may disclose your information to:</p>
            <ul>
              <li>Our affiliated companies</li>
              <li>Third-party service providers, business advisors, or consultants who provide services to us</li>
              <li>In connection with a merger, acquisition, reorganization, restructuring, financing transaction, or sale of assets</li>
              <li>As required by law or administrative order</li>
              <li>To assert claims or rights, or to defend against claims</li>
            </ul>
            <p className="highlight-text">
              We do not share your personal information, phone number, or SMS consent opt-in data with third parties or affiliates for marketing or promotional purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>Protection of Information</h2>
            <p>
              We take steps to protect your information against unauthorized use or disclosure.
            </p>
          </section>

          <section className="legal-section">
            <h2>Updates</h2>
            <p>
              We may periodically update this privacy policy. If we make material changes that have a substantive and adverse impact on your privacy, we will provide notice on this website prior to the change becoming effective. We encourage you to periodically review this page for the latest information about our privacy practices.
            </p>
          </section>

          <section className="legal-section">
            <h2>How to Contact Us</h2>
            <p>
              You can reach us by texting the word <strong>HELP</strong> for support to <a href="tel:410-449-2988" className="legal-link">410-449-2988</a>. You may also contact us directly at <a href="mailto:connect@onealigned.com" className="legal-link">connect@onealigned.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
